import React, { useState } from 'react';
import classes from "./FaqPage.module.css";
import Layout from '../component/Layout';
import SubLayout from '../component/SubLayout';
import Header from '../component/Header';
import { FaArrowLeft, FaChevronDown } from 'react-icons/fa6';
import Container from '../component/Container';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const faqsEnglish = [
    {
        question: "What is MyFootballXI Service?",
        answer: "MyFootball11 is an exciting fantasy football platform where you can build your dream team on real matches, and compete with others to win big!"
    },
    {
        question: "Who is eligible to MyFootballXI Service?",
        answer: "All Vodacom customers are eligible to use MyFootball11 service."
    },
    {
        question: "What benefits can customer find on MyFootballXI Service?",
        answer: "Customers will be able to win various instant prizes. Prizes distribution is as follows.",
        extra: (
            <div className={classes.prizebox}>
                <p className={classes.prizetext}>🏆 Top 5 customers with the highest points at the end of every month will win <strong>Tsh 50,000</strong> each.</p>
            </div>
        )
    },
    {
        question: "How can the customers subscribe to MyFootballXI Service?",
        answer: "Customers can subscribe via the following channels.",
        extra: (
            <div className={classes.channelList}>
                <div className={classes.channelItem}>
                    <span className={classes.channelIcon}>📱</span>
                    <div>
                        <p className={classes.channelTitle}>My Vodacom App</p>
                        <p className={classes.channelDesc}>By selecting <strong>DIGITAL SERVICES</strong> then <strong>TRIVIA</strong> then <strong>MyFootballXI</strong>.</p>
                    </div>
                </div>
                <div className={classes.channelItem}>
                    <span className={classes.channelIcon}>🌐</span>
                    <div>
                        <p className={classes.channelTitle}>PORTAL</p>
                        <p className={classes.channelDesc}>Customers can subscribe by clicking on the service link <a className={classes.link} href="http://vtz.myfootball11.com/" target="_blank" rel="noreferrer">http://vtz.myfootball11.com/</a></p>
                    </div>
                </div>
            </div>
        )
    },
    {
        question: "How much does MyFootballXI Service charge?",
        answer: null,
        extra: (
            <table className={classes.priceTable}>
                <thead>
                    <tr>
                        <th>Subscription Plan</th>
                        <th>Price</th>
                        <th>Validity</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Daily</td>
                        <td>Tsh 300</td>
                        <td>1 day</td>
                    </tr>
                    <tr>
                        <td>Weekly</td>
                        <td>Tsh 700</td>
                        <td>7 days</td>
                    </tr>
                    <tr>
                        <td>Monthly</td>
                        <td>Tsh 1500</td>
                        <td>30 days</td>
                    </tr>
                </tbody>
            </table>
        )
    },
    {
        question: "How can customer opt-out of MyFootballXI Service?",
        answer: null,
        extra: (
            <div className={classes.channelList}>
                <div className={classes.channelItem}>
                    <span className={classes.channelIcon}>📞</span>
                    <div>
                        <p className={classes.channelTitle}>1. Via iCG menu</p>
                        <p className={classes.channelDesc}>Customer will dial <strong>*149*83#</strong> then select a plan they want to unsubscribe from.</p>
                    </div>
                </div>
                <div className={classes.channelItem}>
                    <span className={classes.channelIcon}>🌐</span>
                    <div>
                        <p className={classes.channelTitle}>2. Via the portal</p>
                        <p className={classes.channelDesc}>Customers can unsubscribe at any time via the portal: <a className={classes.link} href="http://vtz.myfootball11.com/" target="_blank" rel="noreferrer">http://vtz.myfootball11.com/</a></p>
                    </div>
                </div>
            </div>
        )
    }
];

const faqsSwahili = [
    {
        question: "MyFootball XI ni nini? Huduma?",
        answer: "MyFootball11 ni jukwaa la kusisimua la soka la ndoto ambapo unaweza kujenga timu yako ya ndoto kwenye mechi halisi, na kushindana na wengine ili kushinda kwa kiasi kikubwa!"
    },
    {
        question: "Nani anayestahili kupata Huduma ya MyFootballXI?",
        answer: "Wateja wote wa Vodacom wanastahili kutumia huduma ya MyFootball11."
    },
    {
        question: "Ni faida gani ambazo mteja anaweza kupata kwenye Huduma ya MyFootballXI?",
        answer: "Wateja wataweza kushinda zawadi mbalimbali za papo hapo. Usambazaji wa zawadi ni kama ifuatavyo.",
        extra: (
            <div className={classes.prizebox}>
                <p className={classes.prizetext}>🏆 Wateja 5 bora walio na pointi za juu zaidi mwishoni mwa kila mwezi watashinda <strong>Tsh 50,000</strong> kila mmoja.</p>
            </div>
        )
    },
    {
        question: "Wateja wanawezaje kujisajili kwa Huduma ya MyFootballXI?",
        answer: "Wateja wanaweza kujisajili kupitia njia zifuatazo.",
        extra: (
            <div className={classes.channelList}>
                <div className={classes.channelItem}>
                    <span className={classes.channelIcon}>📱</span>
                    <div>
                        <p className={classes.channelTitle}>Programu yangu ya Vodacom</p>
                        <p className={classes.channelDesc}>Kwa kuchagua <strong>HUDUMA ZA KIDIJITALI</strong> kisha <strong>TRIVIA</strong> kisha <strong>MyFootballXI</strong>.</p>
                    </div>
                </div>
                <div className={classes.channelItem}>
                    <span className={classes.channelIcon}>🌐</span>
                    <div>
                        <p className={classes.channelTitle}>PORTAL</p>
                        <p className={classes.channelDesc}>Wateja wanaweza kujisajili kwa kubofya kiungo cha huduma <a className={classes.link} href="http://vtz.myfootball11.com/" target="_blank" rel="noreferrer">http://vtz.myfootball11.com/</a></p>
                    </div>
                </div>
            </div>
        )
    },
    {
        question: "MyFootballXI inatoza kiasi gani?",
        answer: null,
        extra: (
            <table className={classes.priceTable}>
                <thead>
                    <tr>
                        <th>Mpango wa Usajili</th>
                        <th>Bei</th>
                        <th>Uhalali</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Kila siku</td>
                        <td>Tsh 300</td>
                        <td>Siku 1</td>
                    </tr>
                    <tr>
                        <td>Kila wiki</td>
                        <td>Tsh 700</td>
                        <td>Siku 7</td>
                    </tr>
                    <tr>
                        <td>Kila mwezi</td>
                        <td>Tsh 1500</td>
                        <td>Siku 30</td>
                    </tr>
                </tbody>
            </table>
        )
    },
    {
        question: "Mteja anawezaje kujiondoa kwenye Huduma ya MyFootballXI?",
        answer: null,
        extra: (
            <div className={classes.channelList}>
                <div className={classes.channelItem}>
                    <span className={classes.channelIcon}>📞</span>
                    <div>
                        <p className={classes.channelTitle}>1. Kupitia menyu ya iCG</p>
                        <p className={classes.channelDesc}>Mteja atapiga <strong>*149*83#</strong> kisha kuchagua mpango anaotaka kujiondoa.</p>
                    </div>
                </div>
                <div className={classes.channelItem}>
                    <span className={classes.channelIcon}>🌐</span>
                    <div>
                        <p className={classes.channelTitle}>2. Kupitia lango</p>
                        <p className={classes.channelDesc}>Wateja wanaweza kujiondoa wakati wowote kupitia lango: <a className={classes.link} href="http://vtz.myfootball11.com/" target="_blank" rel="noreferrer">http://vtz.myfootball11.com/</a></p>
                    </div>
                </div>
            </div>
        )
    }
];

const languageMap = new Map([
    ["0", faqsEnglish],
    ["1", faqsSwahili],
    ["2", faqsSwahili],
    ["3", faqsSwahili],
    ["4", faqsSwahili],
]);

const FaqItem = ({ faq, index }) => {
    const [open, setOpen] = useState(false);

    return (
        <div className={`${classes.faqItem} ${open ? classes.faqItemOpen : ''}`}>
            <button
                className={classes.faqQuestion}
                onClick={() => setOpen(prev => !prev)}
                type="button"
            >
                <span className={classes.qIndex}>Q{index + 1}</span>
                <span className={classes.qText}>{faq.question}</span>
                <FaChevronDown className={`${classes.chevron} ${open ? classes.chevronOpen : ''}`} />
            </button>
            {open && (
                <div className={classes.faqAnswer}>
                    {faq.answer && <p className={classes.answerText}>{faq.answer}</p>}
                    {faq.extra && faq.extra}
                </div>
            )}
        </div>
    );
};

const FaqPage = () => {
    const navigate = useNavigate();
    const { selectedLanguage } = useSelector(state => state.languageSlice);
    const faqs = languageMap.get(selectedLanguage) || faqsEnglish;

    return (
        <Layout>
            <SubLayout>
                <Header active={4} hide={true} />

                <button type="button" className={classes.back_button} onClick={() => navigate(-1)}>
                    <FaArrowLeft color='white' />
                </button>

                <Container style={{ gap: "16px" }}>
                    <div className={classes.card}>

                        <div className={classes.cardHeader}>
                            <span className={classes.headerIcon}>❓</span>
                            <div>
                                <p className={classes.cardTitle}>FAQs</p>
                                <p className={classes.cardSubtitle}>MyFootballXI</p>
                            </div>
                        </div>

                        <div className={classes.faqList}>
                            {faqs.map((faq, index) => (
                                <FaqItem key={index} faq={faq} index={index} />
                            ))}
                        </div>

                    </div>
                </Container>
            </SubLayout>
        </Layout>
    );
};

export default FaqPage;